import {useEffect} from "react";
import ApiService from "../../../services/ApiService";
import {useDataGrid} from "../../../components/data-grid/DataGridContext";
import DataGrid from "../../../components/data-grid/DataGrid";
import UserDashboardData from "../../../components/UserDashboardData";

export default function AdminUserDashboardGrid({userId}) {
    const {setData, setPaginationResult, queryModel, setDataGridProps, resultModel} = useDataGrid();

    const initGridData = async () => {
        if(userId) {
            queryModel.filter = {
                userId
            }
        } else {
            queryModel.filter = {}
        }

        const response = await ApiService.AdminDashboard.GetUserStatistics(queryModel)
        setPaginationResult(response.pagination);
        setData(response.data)
    }

    useEffect(() => {
        initGridData()
    }, [queryModel, userId])

    useEffect(() => {
        setDataGridProps({
            rowKey: 'id',
            enableRowSelection: false,
            columns: [
                {title: 'Register Date', dataIndex: 'registerDate', key: 'registerDate', sorter: false, render: (text, record) => `${new Date(text).toLocaleString()}`},
                {title: 'Name', dataIndex: 'name', key: 'name', sorter: false},
                {title: 'Lastname', dataIndex: 'lastname', key: 'lastname', sorter: false},
                {title: 'Email', dataIndex: 'email', key: 'email', sorter: false,},
                {title: 'Credits', dataIndex: 'totalCredit', key: 'totalCredit', sorter: false,},
                {title: 'Project Uploads', dataIndex: 'projectCount', key: 'projectCount', sorter: false,},
                {title: 'Plan Uploads', dataIndex: 'planCount', key: 'planCount', sorter: false,},
                {title: 'Total Checks', dataIndex: 'checkCount', key: 'checkCount', sorter: false,},
                {title: 'Total Comparison', dataIndex: 'compareCount', key: 'compareCount', sorter: false,},
                {title: 'Total Messages', dataIndex: 'email', key: 'email', sorter: false, render: (text, row) => row.checkMessageCount + row.compareMessageCount},
                // {title: 'Last IP', dataIndex: 'lastReqIp', key: 'lastReqIp', sorter: false, render: (text, record) => (<Typography.Text copyable={true}>{text}</Typography.Text>)},
            ]
        })
    }, [])

    return (
        <>
            {
                userId && (
                    <UserDashboardData
                        projectCount={resultModel.data[0]?.projectCount}
                        planCount={resultModel.data[0]?.planCount}
                        checkCount={resultModel.data[0]?.checkCount}
                        compareCount={resultModel.data[0]?.compareCount}
                        checkMessageCount={resultModel.data[0]?.checkMessageCount}
                        compareMessageCount={resultModel.data[0]?.compareMessageCount}
                    />
                )
            }
            {
                !userId && (
                    <DataGrid />
                )
            }
        </>
    )
}